import React from 'react'
import { CFooter } from '@coreui/react'
import moment from 'moment/moment'

const AppFooter = () => {
  return (
    <CFooter>
      <div>
        {/* <a href="https://coreui.io" target="_blank" rel="noopener noreferrer">
          CoreUI
        </a> */}
        {/* <span className="ms-1">Dev Technosys &copy; 2022 creativeLabs.</span> */}
      </div>
      <div className="ms-auto">
        <span className="me-1">Cue Laundary &copy; {moment().format('YYYY')} </span>
        {/* <a href="https://coreui.io/react" target="_blank" rel="noopener noreferrer">
          CoreUI React Admin &amp; Dashboard Template
        </a> */}
      </div>
    </CFooter>
  )
}

export default React.memo(AppFooter)
